import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const th13MonthSalaryService = (params: {
  page?: number | null;
  limit?: number | null;
  status?: number | null;
  year?: number | null;
  empDeptIds?: number[] | null;
  empTitleCodes?: string[] | null;
  keyword?: string | null;
  empCode?: string | null;
  isAutoReceive?: boolean;
}) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  RestAPIClient.call<RestAPIResponseList<Types.Th13Salary[]>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List13thSalary,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const th13MonthSalaryUpdateBonusService = (data: {
  id: string;
  bonus?: number;
  note?: string;
  standardWorkingDays?: number;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.UpdateBonus.replace("{id}", data.id),
    config: {
      requireAuthentication: true,
    },
    data: {
      bonus: data.bonus,
      note: data.note,
      standardWorkingDays: data.standardWorkingDays,
    },
  });

export const th13MonthSalaryDeleteBonusService = (data: { id: string }) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.DeleteBonus.replace("{id}", data.id),
    config: {
      requireAuthentication: true,
    },
  });
